import { create } from 'zustand';
import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { auth, googleProvider } from '../services/firebase';
import { registerUser, getMe } from '../services/api';

const useAuthStore = create((set, get) => ({
  user: null,
  userDoc: null,
  loading: true,

  init: () => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        set({ user: firebaseUser });
        try {
          const res = await getMe();
          set({ userDoc: res.data, loading: false });
        } catch {
          set({ userDoc: null, loading: false });
        }
      } else {
        set({ user: null, userDoc: null, loading: false });
      }
    });
    return unsubscribe;
  },

  signUp: async (email, password, name, role, extra = {}) => {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await registerUser({ uid: cred.user.uid, name, email, role, ...extra });
    const res = await getMe();
    set({ user: cred.user, userDoc: res.data });
    return cred.user;
  },

  signIn: async (email, password) => {
    const cred = await signInWithEmailAndPassword(auth, email, password);
    const res = await getMe();
    set({ user: cred.user, userDoc: res.data });
    return cred.user;
  },

  signInWithGoogle: async (role = 'student') => {
    const cred = await signInWithPopup(auth, googleProvider);
    // Register if new user
    try {
      await registerUser({ uid: cred.user.uid, name: cred.user.displayName, email: cred.user.email, role });
    } catch {}
    const res = await getMe();
    set({ user: cred.user, userDoc: res.data });
    return cred.user;
  },

  logout: async () => {
    await signOut(auth);
    set({ user: null, userDoc: null });
  },

  resetPassword: async (email) => {
    await sendPasswordResetEmail(auth, email);
  },

  refreshUserDoc: async () => {
    try {
      const res = await getMe();
      set({ userDoc: res.data });
    } catch {}
  },
}));

export default useAuthStore;
